// Module
var code = "<mx-multi-enum-picker ng-if=\"vm.initialized\" ng-required=\"::vm.filter.required\" ng-model=\"vm.value\" selected-items=\"vm.selectedItems\" entity-class-name=\"{{::vm.filter.referenceTo}}\" data-filter=\"vm.filter.referenceFilter\" data-label=\"{{::vm.filter.title}}\" show-state-groups=\"{{::vm.isMultiStateGroups}}\"></mx-multi-enum-picker>";
// Exports
export default code;